import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    border: `${theme.spacing(0.128)} solid ${theme.palette.divider}`,
  },

  card: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  inputsContainer: {
    display: 'flex',
    flexDirection: 'row',

    [theme.breakpoints.down('x-xs')]: {
      flexDirection: 'column',
    },
  },

  inputContainer: {
    width: theme.spacing(18),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  teamName: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: theme.spacing(10),
    paddingBottom: theme.spacing(1),
  },

  errorInput: {
    borderColor: theme.palette.error.main,
  },
}));
